import { wooCommerceGetStatus } from '../helpers/restHelpers'
import { processGetStatusResponse } from '../actions/appActions'

export const getStatusAction = (qString, history) => (dispatch, getState) =>
    new Promise((resolve, reject) => {
        dispatch({ type: 'WOOCOMMERCE_AUTHRESULT' })
        wooCommerceGetStatus(qString)
            .then((response) => {
                dispatch({
                    type: 'WOOCOMMERCE_AUTHRESULT_SUCCESS',
                    payload: response,
                })
                if (history) {
                    processGetStatusResponse(response.data, history)
                        .then(() => resolve(response.data))
                        .catch((error) => reject(error))
                } else {
                    resolve(response.data)
                }
            })
            .catch((error) => {
                dispatch({
                    type: 'WOOCOMMERCE_AUTHRESULT_FAILURE',
                    payload: error,
                })
                reject(error)
            })
    })
